(() => {
  const key = 'ggxReviewProductLinks';
  window[key]?.destroy();
  const handles = new Set([
  "campfire-smores-smores-flavor",
  "cold-brew-frost-giant-roast",
  "cold-brew-frost-giant-roast-kcup-copy",
  "dragons-roast-dark-fire-blend-dark-roast",
  "dwarven-dawn-medium-blend",
  "elders-fathom-medium-dark-roast",
  "elven-enlightenment-canopy-blend-medium-roast",
  "forbidden-frontiers-cinnamon-chocolate-nerdrotic-kcup",
  "goblin-gulp-pathfinder-medium-roast",
  "grind-of-the-guild-bourbon-flavor-k-cup",
  "jungle-haze-toasted-bananas-foster",
  "legend-of-the-loch-highland-cream",
  "maca-mocha-tiki-crunch-1",
  "medieval-mischief-irish-cream-flavored-single-k-cup-pod",
  "molten-moonrise-dark-chocolate",
  "nerdrotic-heritage-roast-dark-roast",
  "nerdrotic-medium-dark-roast",
  "nerdrotic-medium-dark-roast-1",
  "nerdrotic-vanilla",
  "night-of-the-blight-hazelnut-flavor-k-cup-single",
  "night-of-the-chupacabra-chocolate-cinnamon",
  "pumpkin-bomb-spiced-pumpkin-flavor",
  "quest-of-the-paladin-decaf-k-cup",
  "sasquatch-brew-maple-brown-sugar",
  "siege-fuel-medium-roast",
  "silent-night-eggnog-gingerbread",
  "smugglers-run-vanilla-spiced-rum",
  "tracks-of-the-yeti-vanilla-flavor-k-cup-single",
  "witchs-brew-cauldron-blend-dark-roast",
  "wizards-mist-breakfast-blend",
  "yule-fuel-mocha-flavor-coffee",
  "yule-fuel-mocha-flavored-coffee-kcup"
]);
  const hosts = new Set(['geekgrindcoffee.com', 'geek-grind-coffee.myshopify.com']);
  const selector = '.jdgm-rev a.jdgm-rev__prod-link[href]';
  const neutralSelector = '.jdgm-rev [data-ggx-builder-review-product]';
  const controller = new AbortController();
  let observing = false;
  const temporaryFocus = new Set();

  function isBuilderLink(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.matches(selector)) return false;
    try {
      const url = new URL(anchor.getAttribute('href'), document.baseURI);
      if (!['http:', 'https:'].includes(url.protocol) || !hosts.has(url.hostname) || url.port || url.username || url.password) return false;
      const parts = url.pathname.split('/').filter(Boolean).map(decodeURIComponent);
      const index = parts.lastIndexOf('products');
      if (index < 0 || index !== parts.length - 2) return false;
      const prefix = parts.slice(0, index);
      const locale = /^[a-z]{2}(?:-[a-z]{2})?$/i;
      const allowedPrefix = prefix.length === 0
        || (prefix.length === 1 && locale.test(prefix[0]))
        || (prefix.length === 2 && prefix[0] === 'collections')
        || (prefix.length === 3 && locale.test(prefix[0]) && prefix[1] === 'collections');
      return allowedPrefix && handles.has(parts[index + 1]);
    } catch {
      return false;
    }
  }

  function neutralize(anchor) {
    if (!isBuilderLink(anchor)) return;
    const hadFocus = document.activeElement === anchor;
    const text = document.createElement('span');
    for (const name of ['class', 'id', 'title', 'lang', 'dir', 'style']) {
      if (anchor.hasAttribute(name)) text.setAttribute(name, anchor.getAttribute(name));
    }
    text.setAttribute('data-ggx-builder-review-product', '');
    text.style.cursor = 'text';
    text.style.textDecoration = 'none';
    text.append(...anchor.childNodes);
    anchor.replaceWith(text);
    if (hadFocus) {
      text.tabIndex = -1;
      temporaryFocus.add(text);
      text.focus({ preventScroll: true });
      text.addEventListener('blur', () => { text.removeAttribute('tabindex'); temporaryFocus.delete(text); }, { once: true, signal: controller.signal });
    }
  }

  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selector)) neutralize(root);
    root.querySelectorAll(selector).forEach(neutralize);
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.attributeName === 'href') neutralize(record.target);
        else if (record.target.matches('.jdgm-rev, .jdgm-rev__prod-link')) scan(record.target);
      } else {
        record.addedNodes.forEach(scan);
      }
    }
  });

  function start() {
    scan(document);
    if (observing || !document.body) return;
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class'] });
    observing = true;
  }

  function stop() {
    observer.disconnect();
    observing = false;
    temporaryFocus.forEach((node) => node.removeAttribute('tabindex'));
    temporaryFocus.clear();
  }

  function guard(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest(selector);
    const neutral = event.target.closest(neutralSelector);
    if (!neutral && !isBuilderLink(anchor)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (anchor) neutralize(anchor);
  }

  document.addEventListener('click', guard, { capture: true, signal: controller.signal });
  document.addEventListener('auxclick', guard, { capture: true, signal: controller.signal });
  document.addEventListener('keydown', guard, { capture: true, signal: controller.signal });
  document.addEventListener('shopify:section:load', (event) => scan(event.target), { signal: controller.signal });
  window.addEventListener('pagehide', stop, { signal: controller.signal });
  window.addEventListener('pageshow', start, { signal: controller.signal });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true, signal: controller.signal });
  } else {
    start();
  }
  window[key] = { destroy() { stop(); controller.abort(); } };
})();

